import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import ProductProp from '../propTypes/productVariationsProp';

function ShopProductImage({ product, selectedImage }) {
  const userSelected =
    selectedImage && product.images?.find(i => i._id === selectedImage);
  const image = userSelected ? userSelected.url : product.images?.[0]?.url;
  return (
    <>
      <img src={image || '/images/no_image_upload.png'} alt="" />
    </>
  );
}

ShopProductImage.propTypes = {
  product: PropTypes.shape(ProductProp.propType).isRequired,
  selectedImage: PropTypes.string,
};

ShopProductImage.defaultProps = {
  selectedImage: null,
};

export default translate(ShopProductImage);
